<script type="text/javascript">
	import { link } from "svelte-routing";
	export let head,image,preview,views,articleLink;
</script>
<div class="article" itemscope itemtype="http://schema.org/Article">
	<meta itemscope itemprop="mainEntityOfPage" itemType="https://schema.org/WebPage" itemid={"https://tradestore.su"+articleLink} />
	<img src={image} itemscope itemprop="image url contentUrl" itemtype="http://schema.org/ImageObject">
	<div>
		<h3 itemprop="headline name">{head}</h3>
		<p itemprop="description">{preview}</p>
		<div class="area">
			<a class="app_button-secondary" use:link href={articleLink}>Подробнее</a>
		</div>
	</div>
</div>

<style lang="scss">
	.article{
		background: #0F131C;
		border: 1px solid #1A202D;
		border-radius: 4px;
		display: flex;
		@media(max-width:1071px){flex-direction: column;}
		padding: 20px;
		>img{
			object-fit: cover;
			@media(min-width: 1072px) {
				width: 310px;
				height: 310px;
				padding-right: 20px;
			}
			@media(max-width:1071px){
				width: 100%;
				height: 178px;
				padding-bottom: 20px;
			}
			border-radius: 4px;
		}
		>div{
			>p,h3{
				margin: 0;
				padding: 0;}
			>h3{
				border-bottom: 1px solid rgba(255,255,255,.1);
				padding-bottom: 20px;
				margin-bottom: 20px;
				font-size: 11pt; max-width: 350px;
			}
			>p{
				@media(min-width: 1838px) {
					max-width: 370px;
				}
				@media(max-width:1837px){
					max-width: 100%;
				}
				max-height: 160px;
				overflow: hidden;
				word-break: break-word;
				font-style: normal;
				font-weight: 400;
				font-size: 16px;
				color: rgba(255, 255, 255, .5);

			}
			>div.area{
				margin-top: 35px;
				>.app_button-secondary{
					text-decoration: none;
				}
			}
		}
	}
</style>